import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OrderClientRequest } from '../models/order.model';

@Injectable({
  providedIn: 'root'
})
export class OrderClientService {

  private url = environment.api + "api/erp/order-client";
    constructor(
      private http: HttpClient,
    ) { }

  addOrderClient(newOrder: OrderClientRequest) {
      return this.http.post(this.url, newOrder);
    }
}
